import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService} from "../services";
import {Subject} from "rxjs";
import {FormBuilder, FormGroup} from "@angular/forms";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {locale as polish} from "./i18n/pl";
import {locale as english} from "./i18n/en";
import {first} from "rxjs/operators";

import {MatDialog} from "@angular/material/dialog";
import {Page} from "../models/page";
import {NotificationHistoryService} from "./service/notificationHistory.service";
import {NotificationsHistory} from "./model/notificationsHistory";
import {ActivatedRoute} from "@angular/router";
import {User} from "../models";


@Component({
    templateUrl: './notificationHistory.component.html',
    styleUrls: ['./notificationHistory.component.scss',]
})


export class NotificationHistoryComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    deleteDialogRef: any;
    id: string;
    user: User;

    page = new Page();
    @ViewChild(DatatableComponent) table: DatatableComponent;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private notificationHistoryService: NotificationHistoryService,
        private alertService: AlertService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private formBuilder: FormBuilder,
        public _matDialog: MatDialog,
        private route: ActivatedRoute,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;
        this.page.pageNumber = 0;
        this.page.size = 10;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Notifications history');

        this.id = this.route.snapshot.params['id'];
        this.user = new User();
        this.user.id = this.id;
    }

    ngOnInit() {
        this.setPage({offset: 0});
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    setPage(pageInfo) {
        this.loadingIndicator = true;
        this.rows = [];
        this.page.totalElements = 0;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }


        this.notificationHistoryService.getAll(this.id, pageInfo.offset * pageInfo.limit, pageInfo.limit).pipe(first())
            .subscribe((res: NotificationsHistory) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.total;
                    // this.page = pagedData.page;
                },
                error => {
                    this.alertService.error(error);
                })
    }
}
